/**
 * ajaxItem
 * @param item
 * @param getData
 * @param params
 * @param otherContainer
 * @constructor
 */
window.AjaxItem = function (item, getData, params, otherContainer) {
    if (typeof item != 'string') {
        return;
    }
    if (typeof params != 'object') {
        params = {};
    }

    getData = getData || {};
    const self = this;

    let containerList = '#list_' + item;
    if (otherContainer) {
        containerList = '#list_' + otherContainer;
    }

    const defaults = {
        container: containerList,
        ajaxFile: MP_PATH + 'ajax/list/ajax.' + item + '.php',
        callback: function () {
        }
    };
    let config = $.extend(defaults, params);

    /**
     * sortBy
     * @param sortby
     */
    this.sortBy = function (sortby) {
        self.updater({ sortby: sortby });
    };

    /**
     * changePage
     * @param page
     */
    this.changePage = function (page) {
        self.updater({ page: page });
    };

    /**
     * Fügt weitere Elemente aus einem Object hinzu, um diese mit einem späteren Aufruf von updater() zu berücksichtigen
     * @param name
     * @param filter
     */
    this.addFilter = function (name, filter) {
        if (typeof filter == 'object') {
            let filt = [];
            $(filter).each(function () {
                filt[filt.length] = $(this).val();
            });

            let temp = {};
            temp[name] = filt;
            getData = $.extend({}, getData, temp);
        }
    };

    /**
     * loader
     */
    this.loader = function () {
        $.ajax({
            url: config.ajaxFile + '?' + $.param(getData),
            beforeSend: function () {
                $(config.container).html('');
                self.showLoader();
            },
            success: function (html) {
                $(config.container).html(html);
                self.afterLoad();
            }
        });
    };

    /**
     * updater
     * @param getUpdater
     */
    this.updater = function (getUpdater) {
        let data = (typeof getUpdater != 'undefined' ? getUpdater : {});
        data = $.extend(data, { ajax: 1 });

        $.ajax({
            url: config.ajaxFile + '?' + $.param(getData),
            type: 'get',
            data: data,
            beforeSend: function () {
                self.showLoader();
            },
            success: function (html) {
                $(config.container).html(html);
                self.afterLoad();
            }
        });
    };

    /**
     * poster
     * @param postData
     */
    this.poster = function (postData) {
        let data = (typeof postData != 'undefined' ? postData : {});
        data = $.extend(data, { ajax: 1 });
        $.ajax({
            url: config.ajaxFile,
            type: 'post',
            data: data,
            beforeSend: function () {
                self.showLoader();
            },
            success: function (html) {
                $(config.container).html(html);
                self.afterLoad();
            }
        });
    };

    /**
     * afterLoad
     */
    this.afterLoad = function () {
        if (typeof config.callback == 'function') {
            config.callback();
            $('body').find('div.ajaxLoader').remove();
        }
    };

    /**
     * showLoader
     */
    this.showLoader = function () {
        insertAutoLoader($(config.container));
    };
};

/**
 * insertAutoLoader
 * @param into
 */
window.insertAutoLoader = function (into) {
    $(into).prepend('<div class="ajax-loader"></div>');
};

/**
 * Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
 */
window.stickyNavBar = function () {
    if ($(window).scrollTop() >= 80) {
        $('#header').addClass('sticky');
    } else {
        $('#header').removeClass('sticky');
    }
};

/**
 * updateFilter
 * @param element
 * @param optionKey
 * @param value
 */
window.updateFilter = function (element, optionKey, value) {
    var isSelected;

    if ($(element).is(':checkbox')) {
        isSelected = $(element).is(':checked');
    } else {
        if ($(element).hasClass('selected')) {
            $(element).removeClass('selected');
            isSelected = false;
        } else {
            $(element).addClass('selected');
            isSelected = true;
        }
    }

    ListArticles.updater({
        filter: {
            'optionKey': optionKey,
            'value': value,
            'selected': isSelected
        }
    });
};

/**
 *
 * @param password
 * @param outElement
 * @param pwUnsafeTxt
 * @param pwSafeTxt
 */
window.checkPasswordStrength = function (password, outElement, pwUnsafeTxt, pwSafeTxt) {
    const minLength = 10;
    const strengthMax = 4;
    let strength = 0;

    if (password.length >= minLength) {
        strength += 1;
    }
    if (password.match(/[a-zA-Z]+/)) {
        strength += 1;
    }
    if (password.match(/[0-9]+/)) {
        strength += 1;
    }
    if (password.match(/[^A-Za-z0-9]+/)) {
        strength += 1;
    }

    const result = Math.round((strength / strengthMax) * 100);
    if (outElement.is(':hidden')) {
        outElement.show();
    }

    if (result < 100) {
        outElement.removeClass('alert-success');
        outElement.addClass('alert alert-danger').html(pwUnsafeTxt);
    } else {
        outElement.removeClass('alert-danger');
        outElement.addClass('alert success').html(pwSafeTxt);
    }
};

/**
 * build show password icon
 * @param element
 */
window.buildShowPassword = function (element) {
    element.parent('label').append('<span class="showPassword" onclick="showPassword(this); return false;"><span class="mdi mdi-eye"></span>');
};

/**
 * show password
 * @param element
 */
window.showPassword = function (element) {
    var password = $(element).closest('label').find('input');
    if (password.attr('type') === 'password') {
        password.attr('type', 'text');
        $(element).find('span').removeClass('mdi-eye').addClass('mdi-eye-off');
    } else {
        password.attr('type', 'password');
        $(element).find('span').removeClass('mdi-eye-off').addClass('mdi-eye');
    }
};

/**
 * create Range-Slider with input type="range"
 * @param className
 */
window.createRangeSlider = function (className) {
    // Initialize Sliders
    const sliderSections = document.getElementsByClassName(className);
    for (let x = 0; x < sliderSections.length; x++) {
        const sliders = sliderSections[x].getElementsByTagName('input');
        for (let y = 0; y < sliders.length; y++) {
            if (sliders[y].type === 'range') {
                sliders[y].oninput = getSlideVal;
                sliders[y].oninput(this);
            }
        }
    }

    /**
     * getSlideVal
     */
    function getSlideVal () {
        // Get slider values
        const parent = this.parentNode;
        const slides = parent.getElementsByTagName('input');

        let slideMin = parseFloat(slides[0].value);
        let slideMax = parseFloat(slides[1].value);

        // Set range-type
        slides[0].setAttribute('data-range-type', 'min');
        slides[1].setAttribute('data-range-type', 'max');

        // Neither slider will clip the other, so make sure we determine which is larger
        if (slideMin > slideMax) {
            const tmp = slideMax;
            slideMax = slideMin;
            slideMin = tmp;

            // Flip range-type
            slides[0].setAttribute('data-range-type', 'max');
            slides[1].setAttribute('data-range-type', 'min');
        }

        // Display values
        const displayElement = parent.getElementsByClassName('rangeValues')[0];
        if (displayElement !== null) {
            // Format Value
            const formatSlideMin = new Intl.NumberFormat('de-DE', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(slideMin));
            const formatSlideMax = new Intl.NumberFormat('de-DE', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(slideMax));

            // Range Text
            let rangeText = parent.getAttribute('data-range-text');
            if (rangeText !== null) {
                rangeText = rangeText.replace('{min}', '<span id="breite-min" class="min">' + formatSlideMin + '</span>');
                rangeText = rangeText.replace('{max}', '<span id="breite-max" class="max">' + formatSlideMax + '</span>');
                displayElement.innerHTML = rangeText;
            } else {
                displayElement.innerHTML = formatSlideMin + ' - ' + formatSlideMax;
            }
        }

        const bigImg = parent.closest('div').previousElementSibling.getElementsByClassName('big-size')[0].childNodes[0];
        const smallImg = parent.closest('div').previousElementSibling.getElementsByClassName('small-size')[0].childNodes[0];
        if (bigImg !== null) {
            bigImg.style.width = (slideMax * 100 - 80).toString() + 'px';
        }
        if (smallImg !== null) {
            smallImg.style.width = (slideMin * 100 - 80).toString() + 'px';
        }
    }
};